'use client';

import type { PromoCodeState } from '@/lib/cart-persistence';

type Props = {
  promo: PromoCodeState | null;
  className?: string;
};

/** Consistent “you saved” reinforcement for cart + checkout (issue #61). */
export function PromoSavingsBanner({ promo, className = '' }: Props) {
  const amt = promo?.discountAmount ?? 0;
  const code = promo?.code;
  if (amt <= 0 || !code) return null;
  const src = promo?.source ?? 'manual';
  return (
    <div
      role="status"
      className={`rounded-xl border border-green-15 bg-green-5 px-3 py-2.5 text-body-14-desktop text-text-primary ${className}`}
    >
      <p>
        <span className="font-semibold text-green-60">You saved ${amt.toFixed(2)}</span>
        <span className="text-text-secondary"> with {code}</span>.
      </p>
      {src === 'auto' ? (
        <p className="mt-1 text-xs text-text-tertiary">We applied the best eligible offer for your cart.</p>
      ) : null}
    </div>
  );
}
